import { environment } from "~environments/environment";

export const prologLink = (arbetsorderBeteckning: string): string => `${environment.prologBaseUrl}/Web/avverkning/ao/${arbetsorderBeteckning}`;
